import { render, staticRenderFns } from "./TicketInset.vue?vue&type=template&id=01856c04&"
import script from "./TicketInset.vue?vue&type=script&lang=js&"
export * from "./TicketInset.vue?vue&type=script&lang=js&"
import style0 from "./TicketInset.vue?vue&type=style&index=0&id=01856c04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports